import React from "react";
import { TAB_ANALYTICS } from "constants/paths";
import AnalyticsContent from "./AnalyticsContent";
import ContentContacts from "./ContentContacts";

interface IContentTabsRouting {
  tab?: string;
  page?: string;
  setSearchedText: (value: string) => void;
  searchedText: string;
}
const ContentTabsRouting: React.FC<IContentTabsRouting> = ({ tab, page, searchedText, setSearchedText }) => {
  return (
    <>
      {tab === TAB_ANALYTICS.CONTACTS ? (
        <ContentContacts />
      ) : <AnalyticsContent setSearchedText={setSearchedText} searchedText={searchedText} />
      }
    </>
  );
};

export default ContentTabsRouting;
